import { render } from "./JobRelease.vue?vue&type=template&id=501816e9&scoped=true&ts=true"
import script from "./JobRelease.vue?vue&type=script&lang=ts"
export * from "./JobRelease.vue?vue&type=script&lang=ts"

import "./JobRelease.vue?vue&type=style&index=0&id=501816e9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501816e9"]])

export default __exports__